import { Handle, Position } from 'reactflow';

import { VisuallyHidden } from '@components/visually-hidden';

import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

export const Node = (node: JourneyNode<'hidden'>) => (
  <NodeContainer node={node} hideSourceHandle hideTargetHandle>
    <VisuallyHidden>
      <Handle type="target" position={Position.Top} />
    </VisuallyHidden>
    <div style={{ width: 1, height: 1, backgroundColor: 'transparent' }} />
  </NodeContainer>
);
